import type { IconProps } from './types';
import './icons.css';

export default function Frozen({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 16}
      height={height || 17}
      viewBox="0 0 16 17"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={`icon icon-frozen ${className || ''}`}
    >
      <g clipPath="url(#frozen-a)" stroke="currentColor">
        <path
          d="m5.98 1.357.384.48c.897 1.122 2.375 1.122 3.272 0l.385-.48M10.02 15.643l-.384-.48c-.897-1.122-2.375-1.122-3.272
          0l-.385.48M8 2.678V6.5M8 10.5v3.822M13.176 3.179l-.224.573c-.523 1.337.216 2.618 1.636 2.834l.608.092M2.824
          13.821l.224-.573c.523-1.337-.216-2.618-1.636-2.834l-.608-.092M13.041 5.59 9.731 7.5M6.268 9.5l-3.31
          1.91M15.196 10.322l-.608.092c-1.42.216-2.159 1.497-1.636 2.834l.224.573M.804 6.678l.608-.092c1.42-.216
          2.159-1.497 1.636-2.834l-.224-.573M13.041 11.41 9.731 9.5M6.268 7.5l-3.31-1.91"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M8.02 10.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
      </g>
      <defs>
        <clipPath id="frozen-a">
          <path
            fill="currentColor"
            transform="translate(0 .5)"
            d="M0 0h16v16H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
